import { CartAddEvent } from '@theme/events';

const showMessage = (scope, text) => {
  const msg = scope?.querySelector('[data-olki-msg]');
  if (msg) msg.textContent = text;
};

async function addToCart(button) {
  const scope = button.closest('[data-olki-scope]');
  const ids = [];

  if (button.dataset.olkiMain === 'true') {
    const mainInput = document.querySelector('product-form-component input[name="id"]');
    if (!mainInput || !mainInput.value) {
      showMessage(scope, 'Elige la talla del producto antes de agregar el pack.');
      return;
    }
    ids.push(mainInput.value);
  }

  const rows =
    button.dataset.olkiAdd === 'all'
      ? Array.from(scope.querySelectorAll('[data-olki-item]'))
      : [button.closest('[data-olki-item]')];

  for (const row of rows) {
    if (!row) continue;
    const select = row.querySelector('select[data-olki-variant]');
    const id = select ? select.value : row.dataset.variantId;
    if (!id) {
      showMessage(scope, `Elige la talla de ${row.dataset.name}.`);
      select?.focus();
      return;
    }
    ids.push(id);
  }

  if (ids.length === 0) return;

  const sections = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean)
    .join(',');

  const label = button.textContent;
  button.disabled = true;
  showMessage(scope, '');

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
        sections,
      }),
    });
    const data = await response.json();

    if (data.status) {
      showMessage(scope, data.description || data.message || 'No se pudo agregar al carrito.');
      return;
    }

    const cart = await (await fetch('/cart.js')).json();
    document.dispatchEvent(
      new CartAddEvent(cart, 'olki-cross-sell', {
        source: 'olki-cross-sell',
        itemCount: ids.length,
        sections: data.sections,
      })
    );

    button.textContent = 'Agregado ✓';
    setTimeout(() => {
      button.textContent = label;
    }, 2000);
  } catch (error) {
    console.error(error);
    showMessage(scope, 'No se pudo agregar al carrito. Intenta de nuevo.');
  } finally {
    button.disabled = false;
  }
}

if (!window.olkiCrossSellReady) {
  window.olkiCrossSellReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-olki-add]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });
}
